"use client";

import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
import { Table, TableBody, TableCell, TableRow } from "@/components/ui/table";
const universityData = [{
  label: "대학 유형",
  value: "교육부 인가 4년제 정규 사이버대학교"
}, {
  label: "학위",
  value: "4년제 학사학위 (대학원 진학 및 편입 가능)"
}, {
  label: "수업 방식",
  value: "100% 온라인 수업 및 시험 (PC/모바일)"
}, {
  label: "모집 규모",
  value: "전국 최고 수준의 장학 혜택 및 입학 정원"
}, {
  label: "학업유지율",
  value: "90% 이상의 높은 학업 유지율 기록"
}, {
  label: "취업률",
  value: "관련 업계 및 전문직 취업 지원 시스템 운영"
}, {
  label: "모집 기간",
  value: "상반기(12월~2월) / 하반기(6월~8월)"
}, {
  label: "개강",
  value: "1학기(3월) / 2학기(9월)"
}];
export default function UniversitySummaryCard() {
  const reveal = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.15
  });
  return <section data-section-id="1888" id="universitysummarycard" className="relative bg-white overflow-hidden font-sans">
      {}
      <div className="bg-[#1F3864] text-white py-12 md:py-16">
        <div className="mx-auto max-w-[1280px] px-5 md:px-8 text-center">
          <p className="text-sm md:text-base font-light opacity-80 mb-2">
            교육부 인가 4년제 정규 사이버대학
          </p>
          <h2 className="text-2xl md:text-4xl font-bold tracking-tight">
            한눈에 보는 건양사이버대학교
          </h2>
        </div>
      </div>

      {}
      <div ref={reveal.ref} className={`mx-auto max-w-[800px] px-5 md:px-8 py-16 md:py-24 transition-all duration-700 ease-out ${reveal.isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-4"}`}>
        <div className="border border-[#EEF2F7] rounded-lg overflow-hidden shadow-sm">
          <Table>
            <TableBody>
              {universityData.map((item, i) => <TableRow key={i} data-index={i} className="border-[#EEF2F7] hover:bg-slate-50/50 transition-colors">
                  <TableCell className="w-1/3 md:w-1/4 bg-[#F8FAFC] font-medium text-[#64748B] py-4 px-6 border-r border-[#EEF2F7] text-sm md:text-base lg:text-base">
                    {item.label}
                  </TableCell>
                  <TableCell className="text-[#1E293B] py-4 px-6 text-sm md:text-base lg:text-base">
                    {item.value}
                  </TableCell>
                </TableRow>)}
            </TableBody>
          </Table>
        </div>
      </div>

      {}
      <div className="bg-[#F4F8FC] py-10">
        <div className="mx-auto max-w-[600px] px-5 text-center">
          <div className="inline-flex flex-col items-center">
            <p className="text-[#1F3864] font-bold text-lg md:text-xl mb-1">
              입학 문의 1899-3330
            </p>
            <div className="h-1 w-12 bg-[#1F3864]/20 rounded-lg" />
          </div>
        </div>
      </div>
    </section>;
}